import React, {useEffect, useRef, useState} from "react";
import {useLocation,useParams,useHistory} from "react-router-dom";
import "./Customer.scss";
import SimpleLineIcon from "react-simple-line-icons";
import 'swiper/swiper-bundle.min.css'
import Swiper from "swiper";
import {AccessTokenData, ConvertToJalali, FactorData, RateData, RateSend} from "./CustomerServices";
import ReactGA from "react-ga";
import {useDispatchMall} from "../../hooks/useDispatchMall";
import {useDispatchStore, useDispatchUser, usePrompt, useStore} from "../../hooks";
import {InstallData, SetInstallData} from "../../Components/Nav/NavServices";
import {CheckChrom, isInStandaloneMode, LogRequest} from "../../Services";
import {FCMAllow} from "../../Components/NotificationAllow/FCMAllow";
import Invoice from "../Invoice/Invoice";
import {CheckinMall} from "../StoreDetail/StoreDetailServices";


import Lottie from 'react-lottie';
import  animationData from '../../assets/json/gift.json';
import {FactorSec} from "../Home/Sections/FactorSec";
import {ReferralSec} from "../Home/Sections/ReferralSec";
import {InvoiceCoverSec} from "../Home/Sections/InvoiceCoverSec";
import {CampaignList, MyRecentMerchant, RewardList} from "../Home/Sections";
import {MyRecentMerchantMenu} from "../Home/Sections/MyRecentMerchantMenu";
import {TextSec} from "../Home/Sections/TextSec";
import {MultipleList} from "../Home/Sections/MultipleList";
import {MyInvoiceList} from "../Home/Sections/MyInvoiceList";
import {LazyImage, Slider} from "../../Components";
import VideoSec from "../Home/Sections/VideoSec";
import AudioSec from "../Home/Sections/AudioSec";
import SeeMore from "../Home/Sections/SeeMore";
import {ProductRegal} from "../../Components/ProductRegal/ProductRegal";
import PollSec from "../Home/Sections/pollSec";

const merchantIgnoreUid = ["Wkhv8PwghL","N6gbxpMed9"]


let mainFactor = {}

function Customer() {

    //states
    const [preload,setPreload] = useState(true);
    const [failed,setFailed] = useState(false);
    const [factor,setFactor] = useState({});
    const [page,set_page] = useState(null);
    const [rate,setRate] = useState(null);
    const [customerRateShow,setCustomerRateShow] = useState(false);
    const [showGiftSection,setShowGiftSection] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [fcmAllow, set_fcmAllow] = useState(false);




    //hooks
    const location = useLocation();
    const { token } = useParams();
    const history= useHistory();
    const setMall = useDispatchMall();
    const setUser = useDispatchUser();
    const prompt = usePrompt();
    const inputRef = useRef(null)
    const fire = useStore();
    const setFire = useDispatchStore();


    // --------------------------------------------------------------------------------- dynamic start


    const [button_list, set_button_list] = useState([]);
    const [button_list2, set_button_list2] = useState([]);
    const [slider, set_slider] = useState([]);
    const [single_bar, set_single_bar] = useState([]);
    const [banner, setBanner] = useState([]);
    const [dual_bar, set_dual_bar] = useState([]);
    const [dual_bar_a, set_dual_bar_a] = useState([]);
    const [triad_big_left, set_triad_big_left] = useState([]);

    const [left, set_left] = useState({});
    const [right_top, set_right_top] = useState({});
    const [right_bottom, set_right_bottom] = useState({});

    const [right, set_right] = useState({});
    const [left_top, set_left_top] = useState({});
    const [left_bottom, set_left_bottom] = useState({});

    const [homi, setHomi] = useState([]);



    const setHome = (home) => {

        let yy = home.data.sortBy('order');
        console.log("4444444444444",yy)
        setHomi(yy)


        //find data ---
        let button_list_loc = home.data.find(data => data.section_type === "button_list");
        let button_list2_loc = home.data.filter(data => data.section_type === "button_list");
        let slider_loc = home.data.find(data => data.section_type === "slider");
        let single_bar_loc = home.data.filter(data => data.section_type === "single_bar");
        let dual_bar_loc = home.data.find(data => data.section_type === "dual_bar");
        let dual_bar_a_loc = home.data.filter(data => data.section_type === "dual_bar");
        let triad_big_left_loc = home.data.find(data => data.section_type === "triad_big_left");
        let triad_big_right_loc = home.data.find(data => data.section_type === "triad_big_right");
        let banner_loc = home.data.find(data => data.section_type === "single_banner");

        if (dual_bar_a_loc) {
            set_dual_bar_a(dual_bar_a_loc)
        }

        // set States
        if (banner_loc) {
            setBanner(banner_loc.items);
        }

        if (button_list_loc) {
            set_button_list(button_list_loc.items)
        }

        if (button_list2_loc) {
            set_button_list2(button_list2_loc)
        }


        if (slider_loc) {
            set_slider(slider_loc.items)
        }

        if (single_bar_loc) {
            let items = single_bar_loc.map(item=>item.items[0]);
            set_single_bar(items)
        }

        if (dual_bar_loc) {
            set_dual_bar(dual_bar_loc.items)
        }


        if (triad_big_left_loc) {
            set_triad_big_left(triad_big_left_loc.items)
        }




        if (triad_big_left_loc) {
            let left_loc = triad_big_left_loc.items.find(data => data.position === "left");
            let left_top_loc = triad_big_left_loc.items.find(data => data.position === "right_top");
            let left_bottom_loc = triad_big_left_loc.items.find(data => data.position === "right_bottom");
            if (left_loc) {
                set_left(left_loc)
            }
            if (left_top_loc) {
                set_left_top(left_top_loc)
            }
            if (left_bottom_loc) {
                set_left_bottom(left_bottom_loc)
            }
        }


        if (triad_big_right_loc) {
            let right_loc = triad_big_right_loc.items.find(data => data.position === "right");
            let right_top_loc = triad_big_right_loc.items.find(data => data.position === "left_top");
            let right_bottom_loc = triad_big_right_loc.items.find(data => data.position === "left_bottom");
            if (right_loc) {
                set_right(right_loc)
            }
            if (right_top_loc) {
                set_right_top(right_top_loc)
            }
            if (right_bottom_loc) {
                set_right_bottom(right_bottom_loc)
            }
        }

    }



    const LinkDispatcher = (link,obj) => {
        switch (link) {
            case 'mall_campaigns':
                history.push('/festivals')
                break;
            case 'mall_campaign_details':
                history.push(`/festival-detail/${obj.link_to_uid}`,{festival:{uid:obj.link_to_uid}})
                break;
            case 'my_rewards':
                history.push('/reward')
                break;
            case 'mall_merchant_details':
                history.push(`/store-detail/${obj.link_to_uid}`,{store:{uid:obj.link_to_uid}})
                break;
            case 'merchant_online_store':
                if(obj.link_to_uid){
                    history.push('/online-store/'+obj.link_to_uid)
                }
                break;
            case 'checkin':
                history.push('/scan')
                break;
            case 'merchant_product':
                let replace = obj.link_to_uid.replace(/'/g, '"');
                let parsedPay =JSON.parse(replace);
                if(parsedPay.merchant_uid && parsedPay.product_uid){
                    history.push(`/online-store-product/${parsedPay.merchant_uid}/${parsedPay.product_uid}`)
                }
                break;
            case 'merchant_category_without_subcategory':
                history.push('/store')
                break;
            case 'mall_food_court':
                history.push('/store',{catLink:{uid:obj.link_to_uid}})
                break;
            case 'credit_package':
                history.push('/reward')
                break;
            case 'mall_parking':
                history.push('/store')
                break;
            case 'mall_event_details':
                history.push(`/event-detail/${obj.link_to_uid}`,{event:{uid:obj.link_to_uid}})
                break;
            case 'merchant_menu':
                history.push(`/menu/${obj.link_to_uid}`,{event:{uid:obj.link_to_uid}})
                break;
            case 'live':
                livePreview(obj)
                break;
            case 'call_center':
                let local_user = localStorage.getItem("user")
                let user_obj = JSON.parse(local_user)
                let new_topic = obj.link_to_uid.replace("REPLACE",user_obj.uid)
                history.push(`/chat/${new_topic}`)
                break;
            default:
                console.log("default")
        }
    }

    const livePreview = (obj)=>{
        window.open(obj.link_to_uid, "_blank")
    }



    // --------------------------------------------------------------------------------- dynamic end


    useEffect(()=>{
        // fetch search params
        // let search = new URLSearchParams(location.search)
        // setId(search.get('name'));

        let us = CheckChrom()
        if(us!=="Google Chrome or Chromium" && us !=="Apple Safari"){
            console.log("Chrommmm");
            window.location.href="intent://"+window.location.host+window.location.pathname+"#Intent;scheme=https;package=com.android.chrome;end;"
        }

        console.log("Location State : ",location.state)
        if(location.state && location.state.factorId){
            getFactor(location.state.factorId);
            getRate(location.state.factorId);
            history.replace('/customer/factor',{...location.state,factorId:null});
        }else {
            let search = new URLSearchParams(location.search)
            let tk = search.get('invoice_token');
            getAccessToken(tk)
        }


    },[])






    function numberWithCommas(x) {
        // convert To toman
        // x= (x/10).toFixed(0)
        //add commas
        if(x){
            return x?x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):0;
        }else {
            return "0"
        }
    }


    function numberSubWithCommas(x) {
        // convert To toman
        // x= (x/10).toFixed(0)
        //add commas
        if(x){
            let num = x.split(".");
            return x?num[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):0;
        }else {
            return "0"
        }
    }

    const [factorResponse,set_factorResponse] = useState(null)


    const getAccessToken = async (tk) => {
        try{
            let response = await AccessTokenData(tk);
            switch (response.status) {
                case 200:
                    localStorage.setItem('token',response.data.user.access_token);
                    localStorage.setItem('shop_token',response.data.user.access_token);
                    //show FCM ALLOW
                    set_fcmAllow(true);
                    //User Set
                    localStorage.setItem('user',JSON.stringify(response.data.user));
                    setUser(response.data.user);
                    if(response.data.invoice_page){
                        console.log("zzzzzzzzzzzzzzzzzzzzz",response.data)
                        set_factorResponse(response.data)
                        set_page(response.data.invoice_page.sections)
                        let home ={data:[]};
                        home['data'] = response.data.invoice_page.sections
                        setHome(home);
                    }

                    getFactor(response.data.invoice_uid);
                    getRate(response.data.invoice_uid);
                    break;
                case 203:
                    //handle factorToken expire Time
                    //get token from response
                    const LoginToken = response.data.token;
                    const factorId = response.data.invoice_uid;
                    history.push("/verify-customer",{token:LoginToken,factorId:factorId})
                    break;
            }
        }catch (e) {
            setFailed(true);
        }
    }

    const getFactor = async (factorId) => {
        try{
            let response = await FactorData(factorId);
            setPreload(false);
            setFactor(response.data);
            mainFactor = response.data

            console.log("factor data ",response.data)
            //Log Chart
            LogRequest({type:"VIEW_INVOICE",meta:response.data.merchant.uid+"_"+response.data.uid})
            console.log(response.data)
            CheckinMall(response.data.merchant.mall.uid)
        }catch (e) {
            setFailed(true);
        }
    }

    //geometry
    // lat : 51.3819623
    // lng : 35.7375291

    const getRate = async (factorId) => {
        try{
            let response = await RateData(factorId);
            setRate(response.data);
            setCustomerRateShow(true);
        }catch (e) {
            switch (e.response.status) {
                case 404:
                    break;
                default:
            }
        }
    }

    const sendRate = async (itemUid) => {
        try{
            return await RateSend(factor.uid,{item_uid :itemUid,des:''});
        }catch (e) {
            //setFailed(true);
        }
    }



    // TSliderDesktop ----------------------------------------------

    const swiper = useRef(null)
    const Loop = ()=>{
        setInterval(()=>{
            swiper.current.slideNext();
        },2000)
    }

    useEffect(()=>{
        swiper.current=new Swiper('.swiper-container',{
            loop:true,
            autoplay: {
                delay: 5000,
            },
        })
        //Loop();
    },[])


    const CheckInstallApi = async () => {
        try {
            //fetch install status
            let response = await InstallData();
            console.log("Response :", response.data);
            //check install status
            if (response.data.length>0) {
                //install => yes
                setShowModal(false);
            } else {
                //install => no
                //check standAlone
                console.log("isInStandaloneMode :", isInStandaloneMode());
                if (isInStandaloneMode()) {
                    // IsStandAlone => yes

                    setShowModal(false);

                    //call Api for set install status
                    let setResponse = await SetInstallData()
                    console.log("Set Res: ",setResponse)
                } else {
                    // IsStandAlone => no
                    ShowInstall().then()
                }
            }
        } catch (e) {
            console.log(e)
        }
    }

    const handleScroll = () =>{
            window.removeEventListener("scroll", handleScroll);
            setTimeout(()=>{
                inputRef.current.click();
            },3000)
    }

    const ShowInstall = async () => {
        //show bundle
        setShowModal(true);

        //show prompt
        try {
            if(!fire){
                prompt.prompt().catch((e)=>{
                    console.log("User Gust error")
                    window.addEventListener("scroll", handleScroll);
                });
                const choiceResult = await prompt.userChoice;
                if (choiceResult.outcome === "accepted") {
                    console.log("User accepted the PWA prompt");
                    setFire(true);
                } else {
                    console.log("User dismissed the PWA prompt");
                    setFire(true);
                }
            }
        } catch (e) {
            //if user gesture error =>
            //scroll listen => after fetch event =>  remove scroll listener => fetch after 3 second => prompt()
            console.log("Event Trigger : ",e)
        }
    }


    const CheckStandAloneMode = async () => {
        console.log("IS standAlone : ",isInStandaloneMode())
        if(isInStandaloneMode()){
            try {
                //fetch install status
                let response = await InstallData();
                if (response.data.length<1) {
                    let setResponse = await SetInstallData();
                    LogRequest({type:"PWA_MODE",meta:""})
                    console.log("Resp : ",setResponse);
                }
            } catch (e) {
                console.log(e)
            }
        }
    }

    const referralShow = ()=>{
        set_isStopped(false)
        setTimeout(()=>{
            gotoReferral()
        },1700)
    }

    const gotoReferral = () =>{

        console.log(mainFactor)

        //Log Chart
        LogRequest({type:"CLICK_MORE",meta:mainFactor.uid})
        localStorage.setItem('mallId',mainFactor.merchant.mall.uid);
        localStorage.setItem('mallLogo',mainFactor.merchant.mall.header_image);
        localStorage.setItem('mallWhite',mainFactor.merchant.mall.logo);
        localStorage.setItem('mallName',mainFactor.merchant.mall.name);
        localStorage.setItem('mall',JSON.stringify(mainFactor.merchant.mall));
        setMall(mainFactor.merchant.mall);
        history.push(`/referral/${mainFactor.merchant.uid}`,{item:mainFactor.merchant})
    }


    const gotoHome = () =>{
        //Log Chart
        LogRequest({type:"CLICK_MORE",meta:factor.uid})
        localStorage.setItem('mallId',factor.merchant.mall.uid);
        localStorage.setItem('mallLogo',factor.merchant.mall.header_image);
        localStorage.setItem('mallWhite',factor.merchant.mall.logo);
        localStorage.setItem('mallName',factor.merchant.mall.name);
        localStorage.setItem('mall',JSON.stringify(factor.merchant.mall));
        setMall(factor.merchant.mall);
        history.push("/home",{customer:true})
    }

    const seeMorePrompt = async () =>{
        if(prompt){
            if(!fire){
                prompt.prompt().catch((e)=>{
                    console.log("User Gust error")
                    gotoHome();
                });
                const choiceResult = await prompt.userChoice;
                if (choiceResult.outcome === "accepted") {
                    console.log("User accepted the PWA prompt");
                    setFire(true);
                    gotoHome()
                } else {
                    console.log("User dismissed the PWA prompt");
                    setFire(true);
                    gotoHome()
                }
            }else {
                gotoHome()
            }
        }else {
            gotoHome()
        }
    }


    const chrome = () =>{
        chrome.browser.openTab()
    }


    useEffect(() => {


        //check StandAloneMode
        CheckStandAloneMode().then();



        //check init & listen Prompt
        // if (prompt) {
        //     console.log("Customer Fetch Prompt", prompt);
        //     CheckInstallApi().then();
        // }
    }, [prompt])


    //animation

    const [isStopped,set_isStopped] = useState(true)
    const [isPaused,set_isPaused] = useState(false)

    const buttonStyle = {
        display: 'block',
        margin: '10px auto'
    };

    const defaultOptions = {
        loop: false,
        autoplay: false,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }

    };




    return(

        <div className="customer-container">
            {/*{fcmAllow?<FCMAllow/>:null}*/}
            <span  ref={inputRef} onClick={async ()=>{
                if(prompt && !fire){
                    prompt.prompt().catch((e)=>{
                        console.log("User Gust error")
                        window.addEventListener("scroll", handleScroll);
                    });
                    const choiceResult = await prompt.userChoice;
                    if (choiceResult.outcome === "accepted") {
                        console.log("User accepted the PWA prompt");
                        setFire(true);
                    } else {
                        console.log("User dismissed the PWA prompt");
                        setFire(true);
                    }
                }
            }}>{""}</span>


            <div className="customer-header">
                <span>فاکتور دیجیتال</span>
                {/*<i className="fa fa-arrow-right"></i>*/}
            </div>




            {!preload?

                <div className="customer-main">
                    {!page?<div className="customer-body">

                        <InvoiceCoverSec factor={factor} />

                        {customerRateShow?<div className="customer-rate">

                            {rate?<Rate rate={rate}  sendRate={sendRate} />:null}

                        </div>:null}


                        <ReferralSec gotoReferral={gotoReferral}/>

                        <FactorSec  factor={factor} gotoHome={gotoHome} showGiftSection={showGiftSection} />

                    </div>:null}

                    {factor && factor.merchant?<SeeMore destination={factorResponse.invoice_page.destination_item} link={factorResponse.invoice_page.destination_link} merchant={factor.merchant}/>:null}

                <div className="customer-footer">

                </div>
            </div>

                // <>
                //
                //  { factor && factor.merchant && !merchantIgnoreUid.includes(factor.merchant.uid) ?<div className="top-float-send-btn"
                //  style={{zIndex:999}}
                //  >
                //      <div className="float-btn" onClick={()=>gotoHome()}>
                //          <i className="fa fa-angle-left"></i>
                //          <span>بیشتر ببینید</span>
                //      </div>
                // </div>:null}
                // <Invoice factor={factor}/>
                // </>
                :<div className="customer-preLoading">
                {!failed?<div className="customer-preloading-body">
                    <img src="/svg/pre.gif" alt=""/>
                    </div>:<div className="customer-failed-body">
                    <img src="/svg/failed.svg" alt=""/>
                    <span>اطلاعاتی موجود نیست</span>
                </div>}


            </div>}



            {!preload ? <div className="new-home" style={{marginTop:57}}>
                {page?                <>


                    {homi.map(item=>{
                        switch (item.section_type) {
                            case 'my_recent_merchant':
                                return (
                                    <MyRecentMerchant item={item}/>
                                )
                                break;
                            case 'video_content':
                                return (
                                    <VideoSec item={item}/>
                                )
                                break;
                            case "mall_products":
                                return(
                                    <ProductRegal item={item}/>
                                )
                                break;
                            case 'audio_content':
                                return (
                                    <AudioSec item={item}/>
                                )
                                break;
                            case 'merchant_menu':
                                return (
                                    <MyRecentMerchantMenu item={item}/>
                                )
                                break;
                            case 'invoice_text':
                                return (
                                    <FactorSec item={item} factor={factor} gotoHome={gotoHome} showGiftSection={showGiftSection} />
                                )
                                break;
                            case 'address_bar':
                                return (
                                    <ReferralSec gotoReferral={gotoReferral}/>
                                )
                                break;

                            case 'invoice_cover':
                                return (
                                    <InvoiceCoverSec factor={factor} />
                                )
                                break;

                            case 'rate':
                                return (
                                    <>
                                        {customerRateShow?<div className="customer-rate">

                                            {rate?<Rate rate={rate}  sendRate={sendRate} />:null}

                                        </div>:null}
                                    </>
                                )
                                break;
                            case 'poll':
                                return (
                                    <PollSec item={item}/>
                                )
                                break;
                            case 'reward_list':
                                return (
                                    <RewardList item={item}/>
                                )
                                break;
                            case 'campaign_list':
                                return (
                                    <CampaignList item={item}/>
                                )
                                break;
                            case 'blogpost_text':
                                return (
                                    <TextSec item={item}/>
                                )
                                break;
                            case 'multiple_banner':
                                return (
                                    <MultipleList item={item}/>
                                )
                                break;
                            case 'my_invoice_list':
                                return (
                                    <MyInvoiceList item={item}/>
                                )
                                break;
                            case 'slider':
                                return (
                                    <div>
                                        <Slider uid={item.uid} dispatch={LinkDispatcher} data={item.items}/>
                                    </div>
                                )
                                break;
                            case 'dual_bar':
                                return (
                                    <div className="block-pool" style={{order: 2}}>

                                        <div className="block-item-horizontal">
                                            <div className="wrapper" onClick={() => LinkDispatcher(item.items[0].link_to,item.items[0])}>
                                                {item.items[0] ?
                                                    <>
                                                        {/*<img src={item.items[0].image} alt=""/>*/}
                                                        <LazyImage type={'side'} src={item.items[0].image}/>
                                                        <span className="block-title">{item.items[0].title}</span>
                                                    </>
                                                    : null}
                                            </div>

                                            <div className="wrapper" onClick={() => LinkDispatcher(item.items[1].link_to,item.items[1])}>
                                                {item.items[1] ?
                                                    <>
                                                        {/*<img src={item.items[1].image} alt=""/>*/}
                                                        <LazyImage type={'side'} src={item.items[1].image}/>
                                                        <span className="block-title">{item.items[1].title}</span>
                                                    </>
                                                    : null}
                                            </div>
                                        </div>
                                    </div>
                                )
                                break;
                            case 'single_bar':
                                return (
                                    <div key={item.items[0].uid} className="single-bar" onClick={() => LinkDispatcher(item.items[0].link_to,item.items[0])}>
                                        <>
                                            {/*<img  src={item.items[0].image} alt=""/>*/}
                                            <LazyImage type={'banner'} src={item.items[0].image}/>
                                            <span className="block-title">{item.items[0].title}</span>
                                        </>
                                    </div>
                                )
                                break;
                            case 'single_banner':
                                return (
                                    <div key={item.items[0].uid} className="single-bar" onClick={() => LinkDispatcher(item.items[0].link_to,item.items[0])}>
                                        <>
                                            {/*<img  src={item.items[0].image} alt=""/>*/}
                                            <LazyImage type={'banner'} src={item.items[0].image}/>
                                            <span className="block-title">{item.items[0].title}</span>
                                        </>
                                    </div>
                                )
                                break;
                            case 'triad_big_right':
                                return (
                                    <div className="block-container">
                                        {/*left*/}
                                        {/*right*/}
                                        {right.image?<div className="block-pool" style={{order: 1}}>
                                            <div className="block-item-vertical">
                                                <div className="wrapper" onClick={() => LinkDispatcher(right_top.link_to,right_top)}>
                                                    <img className="max-height" src={right_top.image} alt=""/>
                                                    <span className="block-title">{right_top.title}</span>
                                                </div>
                                                <div className="wrapper" onClick={() => LinkDispatcher(right_bottom.link_to,right_bottom)}>
                                                    <img  className="max-height" src={right_bottom.image} alt=""/>
                                                    <span className="block-title">{right_bottom.title}</span>
                                                </div>
                                            </div>
                                            <div className="block-item-vertical">
                                                <div className="wrapper" onClick={() => LinkDispatcher(right.link_to,right)}>
                                                    <img src={right.image} alt=""/>
                                                    <span className="block-title">{right.title}</span>
                                                </div>
                                            </div>
                                        </div>:null}
                                    </div>
                                )
                                break;
                            case 'triad_big_left':
                                return (
                                    <div className="block-container">
                                        {/*left*/}
                                        {left.image?<div className="block-pool" style={{order: 1}}>
                                            <div className="block-item-vertical">
                                                <div className="wrapper" onClick={() => LinkDispatcher(left.link_to,left)}>
                                                    <img src={left.image} alt="" />
                                                    <span className="block-title">{left.title}</span>
                                                </div>
                                            </div>
                                            <div className="block-item-vertical">

                                                <div className="wrapper" onClick={() => LinkDispatcher(left_top.link_to,left_top)}>
                                                    <img  className="max-height" src={left_top.image} alt=""/>
                                                    <span className="block-title">{left_top.title}</span>
                                                </div>
                                                <div className="wrapper" onClick={() => LinkDispatcher(left_bottom.link_to,left_bottom)}>
                                                    <img className="max-height"   src={left_bottom.image} alt=""/>
                                                    <span className="block-title">{left_bottom.title}</span>
                                                </div>
                                            </div>
                                        </div>:null}
                                    </div>
                                )
                                break;

                            case 'button_list':
                                return (
                                    <div className="digi_badg_actions">
                                        {item.items.map(itemz => {
                                            return (
                                                <div key={itemz.uid} className="digi_badg_actions_item" onClick={()=>{ LinkDispatcher(itemz.link_to,itemz)}}>
                                                    <img src={itemz.image} alt="" style={{width: 48}}/>
                                                    <span>{itemz.title}</span>
                                                </div>
                                            )
                                        })}
                                    </div>
                                )
                                break;
                        }
                    })}

                </>
                :null}
            </div> : <div className="customer-preLoading">
                {!failed ? <div className="customer-preloading-body">
                    <img src="/svg/pre.gif" alt=""/>
                </div> : <div className="customer-failed-body">
                    <img src="/svg/failed.svg" alt=""/>
                    <span>اطلاعاتی موجود نیست</span>
                </div>}
            </div>}



        </div>
    )
}

function RateSmileItem({item,setSelected,selectedId}) {
    return(
        <div className="smile-rate-item" onClick={
            ()=>{
                setSelected(item.uid)
            }
        }>
            <img src={selectedId===item.uid?item.selected_image:item.image} alt=""/>
            <span>{item.title}</span>
        </div>
    )
}

function RateStarItem({set,star,select}){

    return(
        <div
            className="rateStarItem"
            onMouseOver={()=>{set(star.id);}}
            onClick={()=>select(star)}
        >
            {star.status?<SimpleLineIcon name="star" color={"#FFDD6F"}/>:<SimpleLineIcon name="star"/>}
            {/*<i className="fa fa-star-o"*/}
            {/*   style={star.status?{color:"yellow"}:{color:"white"}}*/}
            {/*   onMouseOver={()=>{set(star.id);}}*/}
            {/*   onClick={()=>select(star)}*/}
            {/*>*/}
            {/*</i>*/}
        </div>
    )
}


function RateStar({rate,sendRate}) {

    const [send,setSend] = useState(false);
    const [loading,setLoading] = useState(false);
    const [stars,setStars] = useState([
        {id:1,status:false},
        {id:2,status:false},
        {id:3,status:false},
        {id:4,status:false},
        {id:5,status:false},
    ])

    useEffect(()=>{
        let selectedStar = rate.items.find(item=>item.is_selected===true);
        console.log(selectedStar)
        if(selectedStar){
            setSend(true);
            changeStars(rate.items.indexOf(selectedStar)+1)
        }
    },[])

    const changeStars = (id)=>{
        if(send){return};
        switch (id) {
            case 1:
                setStars([{id:1,status:true}, {id:2,status:false}, {id:3,status:false}, {id:4,status:false}, {id:5,status:false},])
                break;
            case 2:
                setStars([{id:1,status:true}, {id:2,status:true}, {id:3,status:false}, {id:4,status:false}, {id:5,status:false},])
                break;
            case 3:
                setStars([{id:1,status:true}, {id:2,status:true}, {id:3,status:true}, {id:4,status:false}, {id:5,status:false},])
                break;
            case 4:
                setStars([{id:1,status:true}, {id:2,status:true}, {id:3,status:true}, {id:4,status:true}, {id:5,status:false},])
                break;
            case 5:
                setStars([{id:1,status:true}, {id:2,status:true}, {id:3,status:true}, {id:4,status:true}, {id:5,status:true},])
                break;
        }
    }

    const select= async (star) =>{
        // ReactGA.event({category: 'Customer', action: 'Sent Rate'});

        if(!send){
            setLoading(true);
            try {
                let response = await sendRate(rate.items[star.id-1]?rate.items[star.id-1].uid:5);
                setLoading(false);
                setSend(true);
                console.log(response);
            }catch (e) {
                setLoading(false);
                setSend(true);
                console.log(e);
            }
        }
    }


    return(
        <>
            <div className="rate-stars">
                <div className="rate-stars-wrapper">
                    {
                        stars.map(star=>{
                            return(
                                <RateStarItem select={select} star={star} set={changeStars}/>
                            )
                        })
                    }
                </div>
                {!loading && send?<div className="send-mode">
                    <span className="customer-rate-after-question">از نظر شما متشکریم</span>
                </div>:null}
                {loading? <div className="rate-loading">
                    <span>در حال ارسال نظر</span>
                    <img src="/other/rate-preload.gif" alt=""/>
                </div>:null}
            </div>
        </>
    )
}

function Rate({rate,sendRate}) {

    const [uid,setUid] = useState("");
    const [send,setSend] = useState(false);
    const [loading,setLoading] = useState(false);
    const [sendTitle,setSendTitle] = useState("از نظر شما متشکریم");

    const setSelected = async id =>{
        //pre proccess
        if(!send){
            setLoading(true);
            setUid(id);
            try {
                let response = await sendRate(id);
                setLoading(false);
                setSend(true);
                console.log(response);
            }catch (e) {
                setLoading(false);
                setSend(false);
                console.log(e);
            }
        }
    };

    return(
        <>

            {/*{!loading && !send?*/}
            <div className="rate-mode">
                <span className="customer-rate-message">{rate.description}</span>
                <span className="customer-rate-question">{rate.title}</span>
                <div className="smile-rate">
                    <RateStar rate={rate} sendRate={sendRate}/>
                    {/*{rate.items && rate.items.map(item=>{*/}
                    {/*    return(*/}
                    {/*        <RateSmileItem key={item.uid} item={item} setSelected={setSelected} selectedId={uid}/>*/}
                    {/*    )*/}
                    {/*})}*/}
                </div>
            </div>
            {/*:null}*/}
            {!loading && send?<div className="send-mode">
                <span className="customer-rate-after-question">از نظر شما متشکریم</span>
            </div>:null}
            {loading? <div className="rate-loading">
                <span>در حال ارسال نظر</span>
                <img src="/other/rate-preload.gif" alt=""/>
            </div>:null}
        </>
    )

}



export {Customer}


